//NPM LIBRARIES
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import AUtextInput from '@gov.au/text-inputs';
import { AUerrorText, AUfieldset, AUformGroup, AUhintText, AUlabel } from '@gov.au/form';

//REDUX ACTIONS AND SELECTORS
import { getFormDataSelector } from '../../FormStore/Selectors/FormDataSelectors'

//COMPONENTS AND UTILITIES
import { validateAnswerHasValue } from './Utilities';
import RadioButtonGroup from './RadioButtonGroup';
import DateFieldset from '../CASAForm/ReusableQuestions/DateFieldSet';
import MeasurementInput from '../CASAForm/ReusableQuestions/MeasurementInput';
import Select from './ReusableQuestions/Select';
import GoogleMapAddressPicker from '../CASAForm/ReusableQuestions/GoolgeMapAddressPicker';
import TimeInputFields from '../CASAForm/ReusableQuestions/TimeInputFields';
import Declaration, { ConditionalDeclaration } from '../CASAForm/ReusableQuestions/Declaration';
import GoogleMapsLoader from '../CASAForm/ReusableQuestions/GoogleMapsLoader';
import FilePicker from "./ReusableQuestions/FilePicker";
import AutoComplete from "./ReusableQuestions/AutoComplete";
import TextCheckboxEnabled from './CustomComponents/TextCheckboxEnabled';

const numberOnlyRegexPattern = new RegExp("^[0-9]*$")

class Question extends Component {
    constructor(props) {
        super(props);

        let answer = {
            value: '',
            checkboxes: {},
            checked: false //for dtl (temporary?)
        };
        let errorMessage = null; //changed to null

        //added
        if (props.errorMessage && props.errorMessage !== '') {
            errorMessage = props.errorMessage
        }

        if (props.initialValue) {
            answer.value = props.initialValue
        }

        if (props.formData.steps?.length > 0 && props.showAnswer) {
            const currentStep = props.formData.steps.find(step => step.stepid === props.stepid);
    
            if (currentStep && currentStep.questions[props.id]) {
                answer = currentStep.questions[props.id].answer;
            }    
        }

        if (props.existingAnswer) {
            answer = props.existingAnswer
        }

        if ((props.mandatory || props.existingAnswer || props.validate) && props.show) { //added validate
            errorMessage = validateAnswerHasValue(props.type, answer, props.mandatory);

            let questionObject = {
                stepid: props.stepid,
                id: props.id,
                validate: props.validate,
                errorMessage: errorMessage,
                mandatory: props.mandatory,
                show: props.show,
                label: props.label,
                type: props.type,
                answer: answer,
                stepShowError: props.stepShowError,
                stepErrorMessage: props.stepErrorMessage
            }

            if (this.props.type != "date" && this.props.returnQuestionData) {
                props.returnQuestionData(questionObject);
            }

        }

        this.state = {
            answer: answer,
            errorMessage: errorMessage
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.show !== prevProps.show && !this.props.show && this.props.removeQuestionData) {
            this.setState({
                answer: {
                    value: '',
                    checkboxes: {}
                }
            })
            this.props.removeQuestionData(this.props.id)

        } else if (this.props.show !== prevProps.show && this.props.show) {
            this.validateAnswerReturnQuestion(this.state.answer);
        }

        if (this.props.overwrite && this.props.existingAnswer && this.props.existingAnswer.value != this.state.answer.value) {
            this.setState({
                answer: this.props.existingAnswer
            })

            this.validateAnswerReturnQuestion(this.props.existingAnswer);
        }
    }

    regexValidation = (regexPattern, answerValue) => {
        if (regexPattern) {
            let regexPatternTest = new RegExp(regexPattern);

            if (!regexPatternTest.test(answerValue)) {
                return false;
            }
        }

        return true;
    }

    saveAnswer = (answer) => {
        this.setState({ answer: answer });
    }

    onBlur = (e) => {
        if (this.props.setDirty) {
            this.props.setDirty();
        }

        if (this.props.validate) {
            this.props.validate(); 
        }
        let errorMessage = validateAnswerHasValue(this.props.type, this.state.answer, this.props.mandatory);

        if (!errorMessage) {
            if (this.props.type === 'number' && (this.props.minValue || this.props.maxValue)) {
                if (this.props.minValue) {
                    if (parseInt(e.target.value) < this.props.minValue) {
                        errorMessage = "Please enter a larger value"
                    }
                } else {
                    if (parseInt(e.target.value) > this.props.maxValue) {
                        errorMessage = "Please enter a smaller value"
                    }
                }
            }

            const isTextInput = ['text', 'textarea', 'number', 'email'].indexOf(this.props.type) !== -1;
            if (isTextInput && (this.props.minLength || this.props.maximumlength)) {
                if (this.props.minLength && this.props.maximumlength) {
                    if (e.target.value.length < this.props.minLength || e.target.value.length > this.props.maximumlength) {
                        errorMessage = `Please check your entry and enter a minimum of ${this.props.minLength} characters and a maximum of ${this.props.maximumlength} characters`;
                    }
                }
                else if (this.props.minLength) {
                    if (e.target.value.length < this.props.minLength) {
                        errorMessage = `Please check your entry and enter a minimum of ${this.props.minLength} characters`;
                    }
                }
                else if (this.props.maximumlength) {
                    if (e.target.value.length > this.props.maximumlength) {
                        errorMessage = `Please check your entry and enter a maximum of ${this.props.maximumlength} characters`;
                    }
                }
            }

            if (!this.regexValidation(this.props.regexPattern, e.target.value)) {
                errorMessage = "Please check the format"
            }
        }

        this.setState({ errorMessage: errorMessage });

        let questionObject = {
            stepid: this.props.stepid,
            id: this.props.id,
            validate: this.props.validate,
            errorMessage: errorMessage,
            mandatory: this.props.mandatory,
            show: this.props.show,
            label: this.props.label,
            type: this.props.type,
            answer: this.state.answer,
            stepShowError: this.props.stepShowError,
            stepErrorMessage: this.props.stepErrorMessage
        }

        if (this.props.onChange) {
            this.props.onChange(questionObject)
        }

        if (this.props.type != "date") {
            this.props.returnQuestionData(questionObject);
        }
    };

    onChangeSelect = (e) => {
        if (this.props.setDirty) {
            this.props.setDirty();
        }

        this.setState({
            'answer': {
                value: e.answer.value,
                key: e.answer.key,
                enccode: e.answer.enccode, 
                refdatatype: e.answer.refdatatype 
            }
        });
    }

    onChange = (e) => {
        if (this.props.type === 'number' && !this.props.regexPattern) {
            if (!numberOnlyRegexPattern.test(e.target.value)) {
                return
            }
        }

        this.setState({ 'answer': { value: e.target.value } });

        if (this.props.setDirty) {
            this.props.setDirty();
        }

        if (this.props.onChange) {
            this.props.onChange(this.props.id, { value: e.target.value }) 
        }
    }

    getStatus = (errorMessage) => {
        if (this.props.showError && errorMessage !== '' && errorMessage !== null) {
            return 'invalid';
        }

        // Added only show step validated error
        if (this.props.stepShowError) {
            return 'invalid';
        }
    }

    createErrorMessage = (errorMessage) => {
        if (this.props.showError && errorMessage) {
            return (<AUerrorText id={`${this.props.id}-error`} type="text" text={errorMessage} />);
        }

        // Added only show step validated error message
        if (this.props.stepShowError && this.props.stepErrorMessage) {
            return (<AUerrorText id={`${this.props.id}-error`} type="text" text={this.props.stepErrorMessage} />);
        }
    } 

    validateAnswerReturnQuestion = (answer) => {
        let errorMessage = validateAnswerHasValue(this.props.type, answer, this.props.mandatory);

        this.setState({
            answer: answer,
            errorMessage: errorMessage
        })

        let questionObject = {
            stepid: this.props.stepid,
            id: this.props.id,
            validate: this.props.validate,
            errorMessage: errorMessage,
            mandatory: this.props.mandatory,
            show: this.props.show,
            label: this.props.label,
            type: this.props.type,
            answer: answer,
            stepShowError: this.props.stepShowError,
            stepErrorMessage: this.props.stepErrorMessage
        }

        this.props.returnQuestionData(questionObject);
    }

    returnCheckboxValues = (optionObject) => {
        let answer = this.state.answer;
        answer.checkboxes[optionObject.optionid] = optionObject;

        if (!answer.checkboxValues) {
            answer.checkboxValues = []
        }

        if (optionObject.check && answer.checkboxValues.indexOf(optionObject.text) === -1) {
            answer.checkboxValues.push(optionObject.text)
        } else {
            answer.checkboxValues = answer.checkboxValues.filter(value => value !== optionObject.text);
        }
        answer.value = answer.checkboxValues.join(", ");

        this.validateAnswerReturnQuestion(answer);
    }

    returnRadioValue = (radioValue) => {
        let answer = this.state.answer;

        answer.value = radioValue.value;
        answer.radioValue = radioValue.radioValue;

        if (this.props.onChange) {
            this.props.onChange(radioValue)
        }

        this.validateAnswerReturnQuestion(answer);
    }

    renderHintText = () => {
        return { __html: '<span className="au-hint-text">' + this.props.hintText + '</span>' };
    }

    createInput = () => {
        if (this.props.show) {
            switch (this.props.type) {
                case "text":
                case "textarea":
                case "number":
                case "email":
                    {
                        return (
                            <AUformGroup
                                className={this.props.className}
                                status={this.getStatus(this.state.errorMessage)}>

                                <AUlabel text={this.props.label} htmlFor={this.props.id} />

                                {this.props.hintText &&
                                    <div dangerouslySetInnerHTML={this.renderHintText()} />
                                }

                                <AUtextInput
                                    type='text'
                                    as={this.props.type === "textarea" ? "textarea" : "input"}
                                    id={this.props.id}
                                    block={this.props.block}
                                    name={this.props.id}
                                    aria-describedby={`${this.props.id}-error`}
                                    status={this.getStatus(this.state.errorMessage)}
                                    onChange={(event) => this.onChange(event)}
                                    onBlur={(event) => this.onBlur(event)}
                                    maximumlength={this.props.maximumlength}
                                    value={this.state.answer.value ? this.state.answer.value : ""}
                                    placeholder={this.props.placeholder}
                                    disabled={this.props.disabled ?? false} />

                                {this.props.toolTip ? <AUhintText text={this.props.toolTip} /> : ""}

                                {this.createErrorMessage(this.state.errorMessage)}

                            </AUformGroup>
                        )
                    }

                case "checkbox":
                    {
                        return (
                            <AUformGroup
                                status={this.getStatus(this.state.errorMessage)}>
                                <AUfieldset>
                                    <AUlabel text={this.props.label} htmlFor={this.props.id} />
                                    {this.props.hintText ? <AUhintText text={this.props.hintText} /> : ""}
                                    <AUformGroup>
                                        {React.Children.map(this.props.children, child => {
                                            return React.cloneElement(child, {
                                                returnCheckboxValues: this.returnCheckboxValues,
                                                status: this.getStatus(this.state.errorMessage),
                                                existingAnswer: (this.props.showAnswer && this.state.answer.value) ? this.state.answer : null //changed?
                                            })
                                        })}
                                    </AUformGroup>
                                </AUfieldset>
                                {this.createErrorMessage(this.state.errorMessage)}
                            </AUformGroup>
                        )
                    }

                case "radio":
                    {
                        return (
                            <RadioButtonGroup
                                {...this.props}
                                status={this.getStatus(this.state.errorMessage)}
                                createErrorMessage={this.createErrorMessage}
                                returnRadioValue={this.returnRadioValue}
                                showError={this.props.showError}
                                existingAnswer= {(this.props.showAnswer && this.state.answer) ? this.state.answer : null}
                                errorMessage={this.state.errorMessage}
                            />
                        )
                    }

                case "date":
                    {
                        return (
                            <DateFieldset
                                {...this.props}
                                getStatus={this.getStatus}
                                createErrorMessage={this.createErrorMessage}
                                returnQuestionData={this.props.returnQuestionData}
                                showError={this.props.showError}
                                existingAnswer={this.state.answer.value ? this.state.answer : null}
                            />
                        )
                    }

                case "measurementInput":
                    {
                        return (
                            <MeasurementInput
                                {...this.props}
                                onBlur={(event) => this.onBlur(event)}
                                getStatus={this.getStatus}
                                createErrorMessage={this.createErrorMessage}
                                returnQuestionData={this.props.returnQuestionData}
                                showError={this.props.showError}
                                existingAnswer={this.state.answer.value ? this.state.answer : null}
                            />
                        )
                    }

                case "select":
                    {
                        return (
                            <Select
                                {...this.props}
                                onBlur={this.onBlur}
                                options={this.props.options}
                                getStatus={this.getStatus}
                                createErrorMessage={this.createErrorMessage}
                                returnQuestionData={this.props.returnQuestionData}
                                showError={this.props.showError}
                                initialValue={this.props.initialValue}
                                existingAnswer={(this.props.showAnswer && this.state.answer.value) ? this.state.answer : null} //changed?
                            />
                        )
                    }

                case "timeInputFields":
                    {
                        return (
                            <TimeInputFields
                                {...this.props}
                                getStatus={this.getStatus}
                                createErrorMessage={this.createErrorMessage}
                                returnQuestionData={this.props.returnQuestionData}
                                showError={this.props.showError}
                                existingAnswer={this.state.answer.value ? this.state.answer : null}
                            />
                        )
                    }

                case "googleMapAddressPicker":
                    {
                        return (
                            <GoogleMapsLoader
                                apiKey={this.props.googleMapsApiKey}>
                                <GoogleMapAddressPicker
                                    {...this.props}
                                    getStatus={this.getStatus}
                                    createErrorMessage={this.createErrorMessage}
                                    showError={this.props.showError}
                                    returnQuestionData={this.props.returnQuestionData}
                                    existingAnswer={this.state.answer.value ? this.state.answer : null}
                                />
                            </GoogleMapsLoader>
                        )
                    }

                case "declaration":
                    {
                        return (
                            <Declaration
                                {...this.props}
                                status={this.getStatus(this.state.errorMessage)}
                                returnCheckboxValues={this.returnCheckboxValues}
                            />
                        )
                    }

                case "conditionalDeclaration":
                    {
                        return (
                            <ConditionalDeclaration
                                {...this.props}
                                status={this.getStatus(this.state.errorMessage)}
                                createErrorMessage={this.createErrorMessage}
                                returnRadioValue={this.returnRadioValue}
                                showError={this.props.showError}
                                existingAnswer={this.state.answer}
                                errorMessage={this.state.errorMessage}
                            />
                        )
                    }

                case "filePicker": {
                    return (
                        <FilePicker
                            {...this.props}
                            getStatus={this.getStatus}
                            createErrorMessage={this.createErrorMessage}
                            returnQuestionData={this.props.returnQuestionData}
                            showError={this.props.showError}
                            existingAnswer={this.state.answer.value ? this.state.answer : null}
                        />
                    )
                }

                case "autoComplete": {
                    return (
                        <AutoComplete
                            {...this.props}
                            getStatus={this.getStatus}
                            createErrorMessage={this.createErrorMessage}
                            returnQuestionData={this.props.returnQuestionData}
                            showError={this.props.showError}
                            existingAnswer={this.state.answer.value ? this.state.answer : null}
                        />
                    )
                }

                case "textCheckboxEnabled": {
                    return (
                        <TextCheckboxEnabled
                            {...this.props} 
                            getStatus={this.getStatus}
                            returnQuestionData={this.props.returnQuestionData}
                            showError={this.props.showError}
                            numpattern={this.props.numpattern}
                            disabled={this.props.disabled}
                            validate={this.props.validate}
                            existingAnswer={(this.props.showAnswer && this.state.answer) ? this.state.answer : null}
                        />
                    )
                }

                default: {
                    return (
                        <Fragment>
                            {this.props.children}
                        </Fragment>
                    )
                }
            }
        }
    }

    render() {
        return (
            <Row noGutters>
                <Col lg={this.props.colspan} md={this.props.colspan} className="float-none">
                    {this.createInput()}
                </Col>
            </Row>
        )
    }
}

Question.propTypes = {
    id: PropTypes.string.isRequired,
    stepid: PropTypes.string.isRequired,
    type: PropTypes.oneOf([
        'email',
        'text',
        'checkbox',
        'radio',
        'number',
        'textarea',
        'timeInputFields',
        'measurementInput',
        'select',
        'date',
        'googleMapAddressPicker',
        'select',
        'declaration',
        'filePicker',
        'autoComplete',
        'conditionalDeclaration',
        'textCheckboxEnabled'
    ]),
    label: PropTypes.string.isRequired,
    block: PropTypes.bool.isRequired,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    minLength: PropTypes.number,
    maximumlength: PropTypes.number,
    validate: PropTypes.func,
    mandatory: PropTypes.bool.isRequired,
    enabled: PropTypes.bool.isRequired,
    show: PropTypes.bool.isRequired,
    regexPattern: PropTypes.string,
    showError: PropTypes.bool,
    returnQuestionData: PropTypes.func,
    dispatch: PropTypes.func,
    googleMapsApiKey: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    placeholder: PropTypes.string,
    options: PropTypes.array,
    hintText: PropTypes.string,
    toolTip: PropTypes.string,
    className: PropTypes.string,
    removeQuestionData: PropTypes.func,
    onChange: PropTypes.func,
    formData: PropTypes.object,
    existingAnswer: PropTypes.object,
    initialValue: PropTypes.string,
    disabled: PropTypes.bool,
    overwrite: PropTypes.bool,
    colspan: PropTypes.number,
    numpattern: PropTypes.string,
    showAnswer: PropTypes.bool,
    errorMessage: PropTypes.string,
    stepShowError: PropTypes.bool,
    stepErrorMessage: PropTypes.string,
    setDirty: PropTypes.func
};

Question.defaultProps = {
    minValue: 0,
    maximumlength: 190,
    initialValue: '',
    block: true,
    mandatory: true,
    enabled: true,
    show: true,
    overwrite: false,
    colspan: 6,
    showAnswer: true,
    stepShowError: false
};

const mapStateToProps = (state) => {
    return {
        googleMapsApiKey: state.B2CSettings.items.GoogleMapsApiKey,
        formData: getFormDataSelector(state.formStore, 'genericFormData'),
    }
}

export default connect(mapStateToProps)(Question);